import React, { useEffect, useState } from "react";
import { api, formatDate } from "@/lib/api";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-logs", { params: { limit: 500 } }).then((r) => setRows(r.data || [])); }, []);
  return (
    <div className="p-6 lg:p-10">
      <div className="mb-6">
        <div className="overline text-zinc-500">JEJAK AKTIVITAS</div>
        <h1 className="font-display font-black text-4xl tracking-tighter">Audit Log</h1>
      </div>
      <div className="border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50 border-b border-border"><tr>
            <th className="text-left p-3 overline">Waktu</th>
            <th className="text-left p-3 overline">Pelaku</th>
            <th className="text-left p-3 overline">Role</th>
            <th className="text-left p-3 overline">Aksi</th>
            <th className="text-left p-3 overline">Target</th>
            <th className="text-left p-3 overline">Detail</th>
          </tr></thead>
          <tbody>
            {rows.length===0 && <tr><td colSpan={6} className="p-8 text-center text-zinc-500">Belum ada log</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-border">
                <td className="p-3 text-xs text-zinc-500 whitespace-nowrap">{formatDate(r.created_at)}</td>
                <td className="p-3">{r.actor_name||"-"}</td>
                <td className="p-3 text-xs uppercase tracking-wider">{r.role}</td>
                <td className="p-3 font-mono text-xs">{r.action}</td>
                <td className="p-3 font-mono text-xs text-zinc-500">{r.target||"-"}</td>
                <td className="p-3 text-xs text-zinc-500 max-w-xs truncate">{r.meta?JSON.stringify(r.meta):""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
